import { inject } from 'vue'
import { TableScope } from '@/components/GraphqlDataTable/injection'
import {
  openContractDetailPanel,
  openClientDetailPanel,
  openPartnerWorkerDetailPanel,
  openRecruiterDetailPanel,
  openWorkerDetailPanel,
  type OpenContractDetailPanelInput,
  type OpenClientDetailPanelInput,
  type OpenPartnerWorkerDetailPanelInput,
  type OpenRecruiterDetailPanelInput,
  type OpenWorkerDetailPanelInput,
} from '@/components/GraphqlDataTable/listners'

/** Opens a detail panel in the table the caller is rendered in. */
export function useTablePanels() {
  const scope = inject(TableScope, '')

  return {
    openWorkerDetailPanel: (input: OpenWorkerDetailPanelInput) =>
      openWorkerDetailPanel(input, scope),
    openPartnerWorkerDetailPanel: (input: OpenPartnerWorkerDetailPanelInput) =>
      openPartnerWorkerDetailPanel(input, scope),
    openContractDetailPanel: (input: OpenContractDetailPanelInput) =>
      openContractDetailPanel(input, scope),
    openRecruiterDetailPanel: (input: OpenRecruiterDetailPanelInput) =>
      openRecruiterDetailPanel(input, scope),
    openClientDetailPanel: (input: OpenClientDetailPanelInput) =>
      openClientDetailPanel(input, scope),
  }
}
